export const typeOfResetPasswordWithTokenDialog = 'typeOfResetPasswordWithTokenDialog';
export const resetPasswordWithTokenDialogSetIsLoadingReducerType = 'resetPasswordWithTokenDialogSetIsLoadingReducerType';
export const resetPasswordWithTokenDialogSetNewPasswordReducerType = 'resetPasswordWithTokenDialogSetNewPasswordReducerType';
export const
  resetPasswordWithTokenDialogSetConfirmationPasswordReducerType = 'resetPasswordWithTokenDialogSetConfirmationPasswordReducerType';
export const resetPasswordWithTokenDialogReducerKey = 'resetPasswordWithTokenDialogReducerKey';
